import { Typography } from "@material-ui/core";
import { FC } from "react";

import { withPercent } from "../../../utils/generic";

const ListPercentValue: FC<any> = ({ record }) => {
  return (
    <>
      <Typography variant="body2">{withPercent(record.discountPercentage)}</Typography>
    </>
  );
};

export default ListPercentValue;
